module.exports = __webpack_public_path__ + "static/media/bonus_level_4.a853fb79.png";